/* tmc-conditions.js — Home slot 04 conditions grid (NW-16, issue #145). Markup and CSS: sections/tmc-conditions.liquid.

   Three layouts share one markup; this script just decides which area is open.
     1200 and up   every area is an open card. Nothing to do.
     768 to 1199   one open card in slot 0. Opening a row swaps it with the open card, in the grid (data-slot)
                   and in the DOM, so the card that closes lands in the row's old place, the section never
                   grows, and tab order keeps matching what is drawn. Tile 08 sits fourth, where it is drawn.
     below 768     a single column. Opening a row opens it in place and closes the one above. Tile 08 is a
                   row that opens into a grey card; its minus button opens the last area again.
   Crossing a breakpoint puts the DOM back in board order (01 to 07, then tile 08) before laying out again.

   THE PANEL. The 21 open panels belong to NW-17. The expand button on an open card fires a cancelable
   `tmc:condition-open` event on document; the panel listens for it and calls preventDefault() once it has
   taken over. detail = { key, title, index, consultLed, eyebrow, trigger }. Until the panel exists the
   button does nothing. NW-25 owns the hover.

   MOTION (NW-24, board motion-conditions-card-expand), run when a visitor opens an area, never when settle() lays
   the grid out again after a breakpoint:
     768 to 1199   a FLIP from the two rects: the tapped row grows from its own place into the open slot (moved and
                   clipped, not scaled, so the card is never squashed) and the old card slides to the row's place.
     below 768     an accordion: the row grows to the card's height in 320ms and its content rises; the area that was
                   open fades its content (120ms), then collapses (220ms). data-closing keeps its card drawn meanwhile.
   Reduced motion: every change is instant, with a short crossfade of the opened content (filter: opacity(), since
   tmc-home.css pins opacity inside .tmc-section). Without element.animate (jsdom) nothing animates. */
(function () {
  'use strict';

  // The section tag sits in the section, so the theme editor can run this file again on every reload.
  if (window.__tmcConditions) return;
  window.__tmcConditions = true;

  var desktop = window.matchMedia('(min-width: 1200px)');
  var tablet = window.matchMedia('(min-width: 768px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OUT = 'cubic-bezier(.22,1,.36,1)';
  /* 390 board F7: an opened row whose top has gone up under the nav scrolls back to 80px from the top of the window,
     which clears the floating nav (read as a window offset, like the 1440 note's 96px; see docs/decisions.md). */
  var SCROLL_TOP = 80;

  function layout() {
    return desktop.matches ? 'static' : tablet.matches ? 'swap' : 'accordion';
  }

  function swapNodes(a, b) {
    var marker = document.createComment('');
    a.parentNode.insertBefore(marker, a);
    b.parentNode.insertBefore(a, b);
    marker.parentNode.insertBefore(b, marker);
    marker.parentNode.removeChild(marker);
  }

  function init(root) {
    if (!root || root.__tmcConditions) return;
    root.__tmcConditions = true;

    var grid = root.querySelector('.tmc-cond__grid');
    var items = [].slice.call(root.querySelectorAll('.tmc-cond__item'));
    var areas = items.filter(function (i) { return i.getAttribute('data-cond') !== 'else'; });
    var tile = items.filter(function (i) { return i.getAttribute('data-cond') === 'else'; })[0];
    var lastArea = areas.filter(isOpen)[0] || areas[0];

    function isOpen(item) { return item.getAttribute('data-open') === 'true'; }

    function setOpen(item, on) {
      item.setAttribute('data-open', on ? 'true' : 'false');
      var row = item.querySelector('.tmc-cond__row');
      if (row) row.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function current() { return items.filter(isOpen)[0]; }

    /* ---- motion ---- */
    var motion = [];
    var cleanups = [];
    function run(el, frames, opts) { var a = el.animate(frames, opts); motion.push(a); return a; }
    /* Ends whatever is running, at once and synchronously, so the next state change starts from a still grid.
       Cleanups are told they were interrupted, so they tidy up without scrolling. */
    function stop() {
      var list = motion, done = cleanups;
      motion = []; cleanups = [];
      list.forEach(function (a) { a.cancel(); });
      done.forEach(function (fn) { fn(true); });
    }
    function after(list, fn) {
      cleanups.push(fn);
      Promise.all(list.map(function (a) { return a.finished; })).then(function () {
        var k = cleanups.indexOf(fn);
        if (k < 0) return;
        cleanups.splice(k, 1);
        fn(false);
      }, function () {});
    }
    function scrollBack(item, smooth) {
      var top = item.getBoundingClientRect().top;
      if (top < SCROLL_TOP) window.scrollBy({ top: top - SCROLL_TOP, behavior: smooth ? 'smooth' : 'auto' });
    }
    function body(item) { return item.querySelector('.tmc-cond__card, .tmc-cond__tile'); }
    function kids(item) {
      var b = body(item);
      return b ? [].filter.call(b.children, function (c) { return c.getClientRects().length; }) : [];
    }

    function animateSwap(was, item, start) {
      var b = body(item);
      if (still.matches) { if (b) run(b, { filter: ['opacity(0)', 'opacity(1)'] }, { duration: 150 }); return; }
      var to = item.getBoundingClientRect();
      var from = start.item;
      var r = b ? getComputedStyle(b).borderTopLeftRadius : '0px';
      run(item, [
        { transform: 'translate(' + (from.left - to.left) + 'px, ' + (from.top - to.top) + 'px)', clipPath: 'inset(0px ' + (to.width - from.width) + 'px ' + (to.height - from.height) + 'px 0px round ' + start.rowRadius + ')', zIndex: 1 },
        { transform: 'none', clipPath: 'inset(0px round ' + r + ')', zIndex: 1 }
      ], { duration: 440, easing: OUT });
      kids(item).forEach(function (c, i) {
        run(c, [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 220, delay: 240 + 30 * Math.min(i, 5), easing: OUT, fill: 'backwards' });
      });
      if (!was) return;
      var at = was.getBoundingClientRect();
      run(was, { transform: ['translate(' + (start.was.left - at.left) + 'px, ' + (start.was.top - at.top) + 'px)', 'none'] }, { duration: 440, easing: OUT });
      run(was, { opacity: [0, 1] }, { duration: 200, delay: 200, easing: 'ease-out', fill: 'backwards' });
    }

    function animateAccordion(was, item, start) {
      if (still.matches) {
        var b = body(item);
        if (b) run(b, { filter: ['opacity(0)', 'opacity(1)'] }, { duration: 120 });
        scrollBack(item, false);
        return;
      }
      var list = [];
      var h = item.getBoundingClientRect().height;
      list.push(run(item, [{ height: start.item.height + 'px', overflow: 'hidden' }, { height: h + 'px', overflow: 'hidden' }], { duration: 320, easing: OUT }));
      kids(item).forEach(function (c, i) {
        list.push(run(c, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 200, delay: 80 + 40 * Math.min(i, 3), easing: 'ease-out', fill: 'backwards' }));
      });
      if (was) {
        var rowH = was.getBoundingClientRect().height;
        was.setAttribute('data-closing', '');
        kids(was).forEach(function (c) { list.push(run(c, { opacity: [1, 0] }, { duration: 120, fill: 'forwards' })); });
        list.push(run(was, [{ height: start.was.height + 'px', overflow: 'hidden' }, { height: rowH + 'px', overflow: 'hidden' }], { duration: 220, delay: 120, easing: 'cubic-bezier(.4,0,1,1)', fill: 'backwards' }));
      }
      after(list, function (interrupted) {
        /* The faded-out content holds opacity 0 until now; let it go, or it would open blank next time. */
        list.forEach(function (a) { a.cancel(); });
        if (was) was.removeAttribute('data-closing');
        if (!interrupted) scrollBack(item, true);
      });
    }

    function swapSlots(a, b) {
      var slot = a.getAttribute('data-slot');
      a.setAttribute('data-slot', b.getAttribute('data-slot'));
      b.setAttribute('data-slot', slot);
      swapNodes(a, b);
    }

    // Board order: areas by their index, slots 0 to 6, then tile 08 last.
    function boardOrder() {
      areas.slice().sort(function (a, b) {
        return Number(a.getAttribute('data-index')) - Number(b.getAttribute('data-index'));
      }).forEach(function (item, k) {
        item.setAttribute('data-slot', String(k));
        grid.appendChild(item);
      });
      if (tile) grid.appendChild(tile);
    }

    function open(item, focus) {
      var was = current();
      if (!item || was === item) return;
      stop();
      var mode = layout();
      var moving = mode !== 'static' && typeof item.animate === 'function';
      var row = item.querySelector('.tmc-cond__row');
      var start = moving ? { item: item.getBoundingClientRect(), was: was && was.getBoundingClientRect(),
        rowRadius: row ? getComputedStyle(row).borderTopLeftRadius : '0px' } : null;
      if (mode === 'swap' && was && item !== tile) swapSlots(was, item);
      if (was) setOpen(was, false);
      setOpen(item, true);
      if (item !== tile) lastArea = item;
      if (moving && mode === 'swap') animateSwap(item === tile ? null : was, item, start);
      if (moving && mode === 'accordion') animateAccordion(was, item, start);
      if (focus) {
        var card = item.querySelector('.tmc-cond__card, .tmc-cond__tile');
        if (card) card.focus({ preventScroll: true });
      }
    }

    // Runs at load and whenever a breakpoint is crossed: leaves exactly one area open, in slot 0 at 768,
    // tile 08 closed unless this is a phone, and the DOM in the order the layout draws it.
    function settle() {
      stop();
      var mode = layout();
      boardOrder();
      if (mode === 'static') return;
      if (tile && isOpen(tile) && mode === 'swap') { setOpen(tile, false); setOpen(lastArea, true); }
      if (mode === 'swap') {
        var open0 = areas.filter(isOpen)[0] || lastArea;
        areas.forEach(function (i) { setOpen(i, i === open0); });
        var atZero = areas.filter(function (i) { return i.getAttribute('data-slot') === '0'; })[0];
        if (atZero && atZero !== open0) swapSlots(atZero, open0);
        var third = [].slice.call(grid.children).filter(function (c) { return c !== tile; })[2];
        if (tile && third) grid.insertBefore(tile, third.nextSibling);
      }
    }

    root.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var row = target.closest('.tmc-cond__row');
      if (row && root.contains(row)) {
        open(row.closest('.tmc-cond__item'), true);
        return;
      }

      if (target.closest('[data-tmc-cond-collapse]')) {
        open(lastArea, true);
        return;
      }

      var expand = target.closest('[data-tmc-condition-open]');
      if (expand && root.contains(expand)) {
        var item = expand.closest('.tmc-cond__item');
        var eyebrow = item.getAttribute('data-panel-eyebrow') || '';
        document.dispatchEvent(new CustomEvent('tmc:condition-open', {
          bubbles: true,
          cancelable: true,
          detail: {
            key: item.getAttribute('data-cond'),
            title: item.getAttribute('data-title') || '',
            index: item.getAttribute('data-index') || '',
            consultLed: eyebrow !== '',
            eyebrow: eyebrow,
            trigger: expand
          }
        }));
      }
    });

    desktop.addEventListener('change', settle);
    tablet.addEventListener('change', settle);
    settle();
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-tmc-conditions]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
